// 一些页面判断客户端给的是全屏还是非全屏窗口
import { getStorage, isPure } from "../utils";

export default function isFullScreen() {
  // 客户端传了全屏或者是h5包 使用px做适配，放弃rem
  return !!getStorage('fullScreen') || !isPure()
}